@if (warningMessage) {
  <app-svg src="/assets/icons/16/alert.svg" class="alert-icon" [appTooltip]="warningMessage"> </app-svg>
}
<app-context-menu [options]="{ width: '260px', noSpacing: true }" #menu>
  <button
    appButton
    name="access-toggle"
    location="gallery-share-context"
    data-test-id="access-toggle"
    class="email-access-toggle"
    [class.center-vertically]="centerVertically"
    [color]="disabled ? 'simple-gray' : red ? 'simple-warn' : 'simple-primary'"
    weight="bold"
    [disabled]="disabled"
    [hasIcon]="true"
    spacing="1"
    shape="round"
    height="1"
    contextButton
  >
    <span>{{ currentAccessLevel | accessLevel }}</span>
    <app-svg src="/assets/icons/16/chevron-down.svg" size="-1"></app-svg>
  </button>
  @if (!disabled) {
    <div contextContent class="button-menu">
      @for (al of accessLevels; track al; let i = $index) {
        <app-button-menu-item
          name="access-{{ mode }}-{{ al }}"
          location="gallery-share-context"
          [color]="
            currentAccessLevel === al ? 'simple-primary' : al === 'remove' || al === 'leave' ? 'simple-warn' : 'simple'
          "
          (onClick)="onChange.emit(al); menu.close()"
          [fullWidth]="true"
          [height]="(type === 'folder' ? alDescriptionFolder : alDescription)[al] ? '3' : '2'"
          [attr.data-test-id]="'access-level_' + al"
          [class.last]="
            accessLevels.includes('make-owner') ? al === 'make-owner' : i === accessLevels.length - 1 && i !== 0
          "
        >
          <div>
            <strong>{{ al | accessLevel }}</strong>
            <span class="action-description">{{ (type === 'folder' ? alDescriptionFolder : alDescription)[al] }}</span>
          </div>
        </app-button-menu-item>
      }
    </div>
  }
</app-context-menu>
